import baseURL from "../common/axios";

class IOLService {
  GetExpectedPatientSurgeryList(Obj) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "IOL/GetExpectedPatientSurgeryList?GivenDate=" +
      Obj.Date +
      "&SiteId=" +
      Obj.SiteId +
      ""
    );
  }

  GetIOLItemsByStoreId(
    FromStoreId,
    ToStoreId,
    ItemName,
    Type,
    FromStoreBrMapId,
    ToStoreBrMapId,
    HospitalId,
    FromStoreBranchId,
    ToStoreBranchId,
    Surgery,
    TreatmentType
  ) {
    return baseURL.httpMSInventoryUrl.get(
      "IOL/GetIOLItemsByStoreId?FromStoreId=" +
      FromStoreId +
      "&ToStoreId=" +
      ToStoreId +
      "&ItemName=" +
      ItemName +
      "&Type=" +
      Type +
      "&FromStoreBrMapId=" +
      FromStoreBrMapId +
      "&ToStoreBrMapId=" +
      ToStoreBrMapId +
      "&HospitalId=" +
      HospitalId +
      "&FromStoreBranchId=" +
      FromStoreBranchId +
      "&ToStoreBranchId=" +
      ToStoreBranchId +
      "&Surgery=" +
      Surgery +
      "&TreatmentType=" +
      TreatmentType +
      ""
    );
  }

  GetIOLItemsByBarCode(StoreId, Barcode, HospitalId, BranchId, Surgery, TreatmentType) {
    return baseURL.httpMSInventoryUrl.get(
      "IOL/GetIOLItemsByBarCode?StoreId=" +
      StoreId +
      "&Barcode=" +
      Barcode +
      "&HospitalId=" +
      HospitalId +
      "&BranchId=" +
      BranchId +
      "&Surgery=" +
      Surgery +
      "&TreatmentType=" +
      TreatmentType +
      ""
    );
  }

  CreateIOLAllocation(Obj) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("IOL/CreateIOLAllocation", Obj);
  }

  GetPatientAllocationExists(Obj) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "IOL/GetPatientAllocationExists?BarCodeNo=" +
      Obj.BarCodeNo +
      "&UIN=" +
      Obj.uin +
      "&ExpectedAdmissionDate=" +
      Obj.expectedAdmissionDate +
      "&StoreId=" +
      Obj.StoreId +
      "&BranchId=" +
      Obj.BranchId +
      "&HospitalId=" +
      Obj.HospitalId +
      ""
    );
  }

  GetIOLAllocatedItems(Obj) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "IOL/GetIOLAllocatedItems?HospitalId=" +
      Obj.HospitalId +
      "&BranchId=" +
      Obj.BranchId +
      "&StoreId=" +
      Obj.StoreId +
      "&Date=" +
      Obj.Date +
      ""
    );
  }

  CreateIOLStockOut(Obj) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("IOL/CreateIOLStockOut", Obj);
  }

  CreateIOLStockIn(Obj) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("IOL/CreateIOLStockIn", Obj);
  }

  CreateIOLIssue(Obj) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("IOL/CreateIOLIssue", Obj);
  }

  UpdateStockOutStockIn(Obj) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("IOL/UpdateStockOutStockIn", Obj);
  }

  UpdateConsumption(Obj) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("IOL/UpdateConsumption", Obj);
  }

  GetIOLStockOut(Obj) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "IOL/GetIOLStockOut?HospitalId=" +
      Obj.HospitalId +
      "&BranchId=" +
      Obj.BranchId +
      "&StoreId=" +
      Obj.StoreId +
      "&StoreBrMapId=" +
      Obj.StoreBrMapId +
      "&DocType=" +
      Obj.DocType +
      "&Date=" +
      Obj.Date +
      ""
    );
  }

  GetIOLIssueByStockOutId(Obj) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "IOL/GetIOLIssueByStockOutId?StockOutId=" + Obj.StockOutId + ""
    );
  }

  GetIssuedItemsByStockOutId(Obj) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "IOL/GetIssuedItemsByStockOutId?StockOutId=" +
      Obj.StockOutId +
      "&Date=" +
      Obj.Date +
      ""
    );
  }

  GetAdmittedPatientSurgeryList(Obj) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "IOL/GetAdmittedPatientSurgeryList?GivenDate=" +
      Obj.Date +
      "&SiteId=" +
      Obj.SiteId +
      ""
    );
  }

  GetSurgeryListMMS(Obj) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "IOL/GetSurgeryListMMS?GivenDate=" +
      Obj.Date +
      "&SiteId=" +
      Obj.SiteId +
      ""
    );
  }

  GetDeptStoresByStoreId(Obj) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "IOL/GetDeptStoresByStoreId?StoreId=" +
      Obj.StoreId +
      "&BranchId=" +
      Obj.BranchId +
      "&HospitalId=" +
      Obj.HospitalId +
      ""
    );
  }

  GetUserByStoreId(Obj) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "IOL/GetUserByStoreId?StoreId=" +
      Obj.ToStoreId +
      "&HospitalId=" +
      Obj.HospitalId +
      ""
    );
  }

  GetIOLReturnReason(obj) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "IOL/GetIOLReturnReason?HospitalId=" + obj.HospitalId + ""
    );
  }

  GetConsumptionDetailsByStoreId(obj) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "IOL/GetConsumptionDetailsByStoreId?HospitalId=" +
      obj.HospitalId +
      "&BranchId=" +
      obj.BranchId +
      "&StoreId=" +
      obj.StoreId +
      "&Date=" +
      obj.Date +
      ""
    );
  }

  chkAlreadyAllocation(
    HospitalId,
    BranchId,
    StoreId,
    UIN,
    ExpectedAdmissionDate,
    BarCode
  ) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "IOL/ChkAlreadyAllocation?HospitalId=" +
      HospitalId +
      "&BranchId=" +
      BranchId +
      "&StoreId=" +
      StoreId +
      "&UINnumber=" +
      UIN +
      "&AdmissionDate=" +
      ExpectedAdmissionDate +
      "&BarCode=" +
      BarCode +
      ""
    );
  }

  IOLAllocationCancel(AllocationId) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "IOL/IOLAllocationCancel?AllocationId=" + AllocationId + ""
    );
  }

  GetIOLItemsBySurgeryName(
    FromStoreId,
    ToStoreId,
    Type,
    FromStoreBrMapId,
    ToStoreBrMapId,
    HospitalId,
    FromStoreBranchId,
    ToStoreBranchId,
    Surgery,
    TreatmentType
  ) {
    return baseURL.httpMSInventoryUrl.get(
      "IOL/GetIOLItemsBySurgeryName?FromStoreId=" +
      FromStoreId +
      "&ToStoreId=" +
      ToStoreId +
      "&Type=" +
      Type +
      "&FromStoreBrMapId=" +
      FromStoreBrMapId +
      "&ToStoreBrMapId=" +
      ToStoreBrMapId +
      "&HospitalId=" +
      HospitalId +
      "&FromStoreBranchId=" +
      FromStoreBranchId +
      "&ToStoreBranchId=" +
      ToStoreBranchId +
      "&Surgery=" +
      Surgery +
      "&TreatmentType=" +
      TreatmentType +
      ""
    );
  }
}

export default new IOLService();
